import { clientConstants as constants } from '../_constants/client.constants';

export const initialState = {
  id: null,
  name: "",
  services: {},
  accountDomain: "",
  landingActions: [],
  usersOnline: []
}

export function client(state = initialState, action) {
  if (action.type === constants.CLIENT_SET_USERS_ONLINE) {
    return {
      ...state,
      usersOnline: action.users
    }
  }

  if (action.type === constants.CLIENT_ADD_USER_ONLINE) {
    return {
      ...state,
      usersOnline: [
        ...state.usersOnline,
        { ...action.user }
      ]
    }
  }

  if (action.type === constants.CLIENT_REMOVE_USER_ONLINE) {
    return {
      ...state,
      usersOnline: state.usersOnline.filter(online => {
        return online.userId !== action.userId
      })
    }
  }

  if (action.type === constants.SET_SERVICES) {
    return {
      ...state,
      services: action.services
    }
  }

  if (action.type === constants.SET_ACCOUNT) {
    return {
      ...state,
      ...action.account
    }
  }

  return state;
}
